export const BreakPoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const TimeSlots = {
  "10to12" : "10:00AM to 12:00PM",
  "12to2" : "12:00PM to 2:00PM",
  "2to4" : "2:00PM to 4:00PM",
  "4to6" : "4:00PM to 6:00PM",
  "6to8" : "6:00PM to 8:00PM",
};

export const SalesLeadStatus = [
  { label: "Owner Not Available, Visit Again", value: "tryagain" },
  { label: "Owner Interested, Visit Again", value: "visit" },
  { label: "Maybe Later", value: "later" },
  { label: "Not Interested", value: "no" },
  { label: "Signed", value: "signed" },
];

export const SalesLeadFilter = [
  { label: "All", value: "all" },
  { label: "No PlaceID", value: "noplaceid" },
  { label: "Unverified PlaceID", value: "unverifiedplaceid" },
];

export const adminSalesFutureFilter = [
  { label: "Without Lead", value: "withoutlead" },
  { label: "With Lead - no signup", value: "withleadonly" },
  { label: "Signed", value: "signed" },
  { label: "Not Updated", value: "notupdated" },
  { label: "Multi Lead", value: "multilead" },
];

export const adminProductStatus = [
  { label: "Admin - Verified", value: "verified" },
  { label: "Admin - Not Verified", value: "notverified" },
  { label: "Listing - Ready", value: "ready" },
  { label: "Listing - Not Ready", value: "notready" },
  { label: "Deleted", value: "deleted" },
  { label: "Video - With Video", value: "withvideo" },
  { label: "Video - With Video - Unlocked", value: "withvideounlocked" },
  { label: "Video - Without Video", value: "novideo" },
  { label: "Photo - With Photo", value: "withphoto" },
  { label: "Photo - Without Photo", value: "nophoto" },
  { label: "Popular - Is popular", value: "ispopular" },
  { label: "Popular - Is NOT popular", value: "isnotpopular" },
  { label: "Popular - Is Shop popular", value: "isshoppopular" },
  { label: "Popular - Is Shop NOT popular", value: "isshopnotpopular" },
  { label: "Category - Locked", value: "categorylocked" },
  { label: "Category - Unlocked", value: "categoryunlocked" },
  { label: "Category - No Category", value: "nocategory" },
  { label: "Category - With Category", value: "withcategory" },
  { label: "Color - Locked", value: "colorlocked" },
  { label: "Color - Unlocked", value: "colorunlocked" },
  { label: "Color - With Auto Color", value: "withautocolor" },
  { label: "Color - No Auto Color", value: "noautocolor" },
  { label: "Color - With Color", value: "withcolor" },
  { label: "Color - No Color", value: "nocolor" },
  { label: "Wholesale - true", value: "iswholesale" },
  { label: "Wholesale - false", value: "isnotwholesale" },
  { label: "Slug - With UID", value: "withuid" },
  { label: "Slug - Without UID", value: "withoutuid" },
];

export const adminProductSort = [
  { label: "Newest", value: "newest" },
  { label: "Oldest", value: "oldest" },
  { label: "Ranking", value: "productrank" },
];

export const userProductSort = [
  { label: "Popular", value: "popular" },
  { label: "Newest", value: "newest" },
  { label: "Oldest", value: "oldest" },
];

export const adminShopFilter = [
  { label: "All", value: "all" },
  { label: "High Priority - Tracked", value: "tracked" },
  { label: "Low Priority - Not Tracked", value: "nottracked" },
  { label: "Sales - Followup", value: "saleslogfollowup" },
  { label: "Sales - No Visits", value: "nosaleslog" },
  { label: "Sales - High Customer Interest", value: "salesloghighinterest" },
  { label: "Sales - Medium Customer Interest", value: "saleslogmedinterest" },
  { label: "Support - New Ticket", value: "supportticketnew" },
  { label: "No Product Upload (14+ Days)", value: "noproduct14days" },
  { label: "Shop - is popular", value: "ispopular" },
  { label: "Shop - is NOT popular", value: "isnotpopular" },
  { label: "Video Call - Disabled", value: "isnotappointment" },
  { label: "Video Call - Active", value: "isappointment" },
  { label: "Insta - Available", value: "socialpage" },
  { label: "Insta - 1K+ Followers", value: "insta1k" },
  { label: "Insta - No Update (14+ Days)", value: "noinsta14days" },
  { label: "Insta - No sync", value: "instanosync" },
  { label: "Insta - Invalids", value: "instainvalids" },
  { label: "Insta - Not Available", value: "nosocialpage" },
  { label: "No Lead", value: "nolead" },
  { label: "Verified", value: "verified" },
  { label: "Not-Verified", value: "notverified" },
  { label: "Approved", value: "approved" },
  { label: "Approved but inactive", value: "approvedinactive" },
  { label: "Not-Approved", value: "notapproved" },
  { label: "Rejected", value: "rejected" },
  { label: "Not-Rejected", value: "notrejected" },
  { label: "Not-Processed", value: "notprocessed" },
  { label: "No Logo - Active", value: "nologo" },
  { label: "Wholesale - True", value: "iswholesale" },
  { label: "Wholesale - False", value: "isnotwholesale" },
  { label: "Standee - New Request", value: "standeenewrequest" },
  { label: "Standee - In Delivery", value: "standeeindelivery" },
  { label: "Standee - Delivered", value: "standeedelivered" },
];

export const adminShopSort = [
  { label: "Priority - Likecounts", value: "shoprank" },
  { label: "Priority - External - Assigned", value: "priority" },
  { label: "Priority - Internal - Sales", value: "internalpriority" },
  { label: "Insta Followers", value: "instarank" },
  { label: "Insta Likes", value: "instalikes" },
  { label: "No of products", value: "productcount" },
  { label: "Newest", value: "newest" },
  { label: "Oldest", value: "oldest" },
  { label: "Name", value: "name" },
];

export const adminOfferFilter = [
  { label: "All", value: "all" },
  { label: "Offer Active", value: "offeractive" },
  { label: "Offer Inactive", value: "offerinactive" },
  { label: "Offer Deleted", value: "offerdeleted" },
  { label: "Shop Active", value: "shopactive" },
  { label: "Shop Inactive", value: "shopinactive" },
];

export const adminShopLogList = [
  { label: "Customer - Product Upload", value: "product" },
  { label: "Customer - Training/Update", value: "training" },
  { label: "Sales - Video Package", value: "package" },
];

export const adminShopLogInterestList = [
  { label: "High Interest", value: "high" },
  { label: "Medium Interest", value: "medium" },
  { label: "Low Interest", value: "low" },
];

export const adminShopLogStatusList = [
  { label: "New", value: "new" },
  { label: "Follow-up", value: "followup" },
  { label: "Follow-up Rejected", value: "followupreject" },
  { label: "Done", value: "done" },
  { label: "Rejected", value: "rejected" },
];

export const adminShopStatusLogFilter = [
  { label: "High Priority - Tracked", value: "tracked" },
  { label: "Low Priority - Not Tracked", value: "nottracked" },
  { label: "Insta - 1K+ Followers", value: "insta1k" },
];

export const adminShopLogPriorityFilter = [
  { label: "High Interest", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low Interest", value: "low" },
];

export const adminShopSupportTicketStatusList = [
  { label: "Closed", value: "closed" },
  { label: "Assigned", value: "assigned" },
  { label: "New", value: "new" },
];

export const CURRENCY = "\u20B9"; // \u0024 - dollar, \u20B9 - Rupee, \u20AC - Euro
export const DATE_FORMAT = "MMMM Do YYYY";
export const DATE_TIME_FORMAT = "MMMM Do YYYY h:mm a";
export const DATE_TIME_FORMAT_SHORT = "DD-MMM-YY h:mma";
export const DATE_FORMAT_SHORT = "DD-MMM-YY";
export const DATE_TIME_FORMAT_WITH_SEC = "MMMM Do YYYY h:mm:s a";
